var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrapper d-lg-flex"},[_c('chat-menu'),_c('chat-room')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }